import React, { useRef, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useRouteMatch } from "react-router-dom"
import { generatePaginationOptions, updateUrlQueryParam } from "lib/helper"
import { selectLoading } from "modules/notification"
import { getDealerInventoryLooseItemListing, resetDealerInventoryListing } from "modules/stockflow/redux"
import DealerLooseItemListPanelComponent from "./dealerLooseItemListPanel.component"
import {AccessRights} from "lib/constants/accessRights";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function DealerLooseItemListPanelContainer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const match = useRouteMatch()

  const id = match.params.dealerId
  const lang = useSelector(state => state.constant.languages)
  const query = new URLSearchParams(window.location.search);
  const hasStockflowInventoryViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_INVENTORY));

  const isFetching = useSelector(state => selectLoading(state, getDealerInventoryLooseItemListing.typePrefix))

  const totalFiltered = useSelector(state => state.stockflowDealer.inventoryLooseItemList.totalFiltered)
  const totalRecords = useSelector(state => state.stockflowDealer.inventoryLooseItemList.totalRecords)
  const looseItems = useSelector(state => state.stockflowDealer.inventoryLooseItemList.list)

  const isError = useSelector(state => state.stockflowDealer.inventoryLooseItemList.isError)
  const isSearchResult = looseItems.length < totalRecords
  const [paginationOptions, setPaginationOptions] = useState([]);
  const [isFilterUpdated, setIsFilterUpdated] = useState(false)
  const [tableFilter, setTableFilter] = useState({
    page: 0,
    rowsPerPage: 25,
    search: "",
  })

  const tableFilterInitialRef = useRef(true)

  useEffect(() => {
    return () => {
      dispatch(resetDealerInventoryListing())
    }
  }, [dispatch])

  useEffect(() => {
    const isFilter = query.has("is_filter")
    let filter = sessionStorage.getItem(`dealer_loose_filter_${id}`);

    let temp = {...tableFilter}
    if (isFilter && filter) {
      temp = JSON.parse(filter)
      setIsFilterUpdated(true)
    }

    if (isFilter) {
      updateUrlQueryParam(null, ["is_filter"])
    }
    sessionStorage.removeItem(`dealer_loose_filter_${id}`)

    setTableFilter(temp)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!tableFilterInitialRef.current) {
      getData()
    }
    tableFilterInitialRef.current = false
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableFilter])

  useEffect(() => {
    setPaginationOptions(generatePaginationOptions(totalFiltered))
  }, [totalFiltered])

  const getData = () => {
    dispatch(getDealerInventoryLooseItemListing({
      dealer: id,
      length: tableFilter.rowsPerPage,
      start: tableFilter.rowsPerPage * tableFilter.page,
      filter: {
        search: tableFilter.search,
      }
    }))
  }

  const handleChangePage = (event, newPage) => {
    let newData = {
      ...tableFilter,
      page: newPage,
    }
    setIsFilterUpdated(true)
    setTableFilter(newData)
  }

  const handleChangeRowsPerPage = event => {
    let newData = {
      ...tableFilter,
      page: 0,
      rowsPerPage: event.target.value,
    }
    setIsFilterUpdated(true)
    setTableFilter(newData)
  }

  const handleSearch = (filter) => {
    const { search } = filter

    let newData = {
      ...tableFilter,
      page: 0,
      search: search,
    }
    setIsFilterUpdated(true)
    setTableFilter(newData)
  }

  const clearSearch = () => {
    let newData = {
      ...tableFilter,
      page: 0,
      search: "",
    }
    setIsFilterUpdated(false)
    setTableFilter(newData)
  }

  const handleViewDetail = (url) => {
    if (isFilterUpdated) {
      updateUrlQueryParam({ is_filter: true })
      sessionStorage.setItem(`dealer_loose_filter_${id}`, JSON.stringify(tableFilter));
    }
    history.push(url)
  }

  return (
    <DealerLooseItemListPanelComponent
      hasStockflowInventoryViewAccessRight={hasStockflowInventoryViewAccessRight}
      id={id}
      looseItems={looseItems}
      isFetching={isFetching}
      isError={isError}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      page={tableFilter.page}
      rowsPerPage={tableFilter.rowsPerPage}
      totalFiltered={totalFiltered}
      handleSearch={handleSearch}
      clearSearch={clearSearch}
      handleReload={getData}
      isSearchResult={isSearchResult}
      paginationOptions={paginationOptions}
      tableFilter={tableFilter}
      lang={lang}
      handleViewDetail={handleViewDetail}
    />
  )
}

export default DealerLooseItemListPanelContainer
